import { SET_AUDIT} from "../actions/audit";
import produce from "immer";
const INITIAL_STATE = {
  list: []
    
};
export const auditReducer = produce((draft, action) => {
    switch (action.type) {
      case SET_AUDIT:
        draft.list = action.payload;
        break;
      default:
        break;
    }
  }, INITIAL_STATE);